<!-- 
Standard dialog layout for provider task dialogs.
-->
<template>
  <v-dialog 
    v-if="task != null" :value="show" 
    :content-class="`dialog ${size}`" persistent 
  >
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>
            <v-icon v-if="task.type" class="mr-2">{{ getIcon(task.type) }}</v-icon>
            {{ lookups.providerTaskTypeDescriptions[task.type] }}
          </v-toolbar-title>
          <v-spacer/>
          <our-user-guide-button v-if="userGuideTopic" :topic="userGuideTopic" :section="userGuideSection"/>
        </v-toolbar>
        <our-busy-indicator :show="state.processing"/>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
            <p v-if="!hideDescription" v-html="task.description"/>
            <v-layout v-if="hasSlot" wrap>
              <v-flex xs12>
                <slot/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="state.processing" flat @click="$emit('hide')">Cancel</v-btn>
          <v-btn :disabled="state.processing" flat color="primary" @click="$emit('run')">
            {{ lookups.providerTaskTypeDescriptions[task.type] }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" />
    <our-validation-dialog :show="state.error.show" :state-error="state.error" />
  </v-dialog>
</template>

<script>
import mixins from "./mixins";

export default {
  mixins: [mixins],
  props: {
    size: {
      type: String,
      default: "sm"
    },
    hideDescription: {
      type: Boolean,
      default: false
    },
    userGuideTopic: {
      type: String,
      default: null
    },
    userGuideSection: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showValidationDialog: false
    };
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        this.showValidationDialog = true;
        return false;
      }
    }
  }
};
</script>
